/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   stream conversation response bizos
 */

import { Bizo, autoclass } from './base'
import type {
  RawStreamConversationReponse,
  StreamConversationResponse as StreamConversationType,
  StreamToken as StreamTokenType,
} from './streamConversation.types'
import { UnreadCounts } from './streamToken'
import type { RawStreamToken } from './streamToken.types'

export const StreamToken: typeof StreamTokenType = autoclass<StreamTokenType, RawStreamToken>(
  'StreamToken',
  class StreamToken extends Bizo<StreamTokenType, RawStreamToken> {},
  {
    apiKey: 'api_key',
    streamId: 'stream_id',
    token: 'token',
  }
)
export type StreamToken = StreamTokenType
export const StreamConversationResponse: typeof StreamConversationType = autoclass<
  StreamConversationType,
  RawStreamConversationReponse
>(
  'StreamConversationResponse',
  class StreamConversationResponse extends Bizo<
    StreamConversationType,
    RawStreamConversationReponse
  > {},
  {
    streamChannelId: 'stream_channel_id',
    streamToken: { name: 'stream_token', type: StreamToken },
    unreadCounts: { name: 'unread_counts', type: UnreadCounts },
  }
)

export type StreamConversationResponse = StreamConversationType
